import React, { useRef, useImperativeHandle, forwardRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { MapViewCard } from "./card";

// Import Swiper styles
import "swiper/swiper-bundle.min.css";
import cn from "classnames";

const MobileList = forwardRef(
  ({ restaurants, avgPriceLabel, onSlideTo }, ref) => {
    const swiperInstance = useRef(null);

    useImperativeHandle(ref, () => ({
      slideTo: (index, speed = 300) => {
        if (swiperInstance.current) {
          swiperInstance.current.slideTo(index, speed);
        }
      },
      getSwiper: () => swiperInstance.current,
    }));

    return (
      <Swiper
        className={cn("map-swiper", {
          "no-restaurants": restaurants.length === 0,
        })}
        slidesPerView="auto"
        centeredSlides={true}
        spaceBetween={16}
        onSlideChange={(data) => {
          const slide = swiperInstance.current.slides[data.activeIndex];
          onSlideTo(slide.dataset.id);
        }}
        onSwiper={(swiper) => {
          swiperInstance.current = swiper;
        }}
      >
        {restaurants.map((restaurant) => (
          <SwiperSlide key={restaurant.id} data-id={restaurant.id}>
            <MapViewCard
              restaurant={restaurant}
              avgPriceLabel={avgPriceLabel}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    );
  },
);

MobileList.displayName = "MobileList";

export default MobileList;
